import { render, staticRenderFns } from "./CMain.vue?vue&type=template&id=8a7a39b6&scoped=true"
import script from "./CMain.vue?vue&type=script&lang=js"
export * from "./CMain.vue?vue&type=script&lang=js"
import style0 from "./CMain.vue?vue&type=style&index=0&id=8a7a39b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7a39b6",
  null
  
)

export default component.exports